import React from 'react';
import { ArrowRight } from 'lucide-react';
type ShowerQuoteFormProps = {
  onSubmit: (e: React.FormEvent) => void;
};
export function ShowerQuoteForm({
  onSubmit
}: ShowerQuoteFormProps) {
  return <form className="space-y-3" onSubmit={onSubmit} data-id="element-121">
      <div data-id="element-122">
        <label htmlFor="fullName" className="block text-xs font-semibold text-navy-900 mb-1" data-id="element-123">
          Full Name
        </label>
        <input type="text" id="fullName" name="fullName" placeholder="John Smith" autoComplete="name" className="w-full px-3.5 py-2.5 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all bg-gray-50 focus:bg-white text-sm" required data-id="element-124" />
      </div>
      <div data-id="element-125">
        <label htmlFor="phone" className="block text-xs font-semibold text-navy-900 mb-1" data-id="element-126">
          Phone Number
        </label>
        <input type="tel" id="phone" name="phone" placeholder="(555) 123-4567" autoComplete="tel" className="w-full px-3.5 py-2.5 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all bg-gray-50 focus:bg-white text-sm" required data-id="element-127" />
      </div>
      <div data-id="element-128">
        <label htmlFor="email" className="block text-xs font-semibold text-navy-900 mb-1" data-id="element-129">
          Email Address
        </label>
        <input type="email" id="email" name="email" placeholder="john@email.com" autoComplete="email" className="w-full px-3.5 py-2.5 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all bg-gray-50 focus:bg-white text-sm" required data-id="element-130" />
      </div>
      <button type="submit" className="w-full bg-primary hover:bg-primary-hover text-white font-semibold py-3 px-6 rounded-xl transition-colors flex items-center justify-center gap-2 group mt-1 text-sm" data-id="element-131">
        Request My Free Shower Quote
        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-132" />
      </button>
    </form>;
}